import { render, staticRenderFns } from "./MemberReply.vue?vue&type=template&id=0894599c&"
import script from "./MemberReply.vue?vue&type=script&lang=js&"
export * from "./MemberReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports